import { render, staticRenderFns } from "./nav-collapse.vue?vue&type=template&id=686c13da&"
import script from "./nav-collapse.vue?vue&type=script&lang=js&"
export * from "./nav-collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports